const configuration = {
  apiUrl:
    process.env.NODE_ENV === "development"
      ? "https://localhost:44352" // `http://95.217.66.49`,
      : "https://bonusme.uk/",
      //  "https://bonusme-staging.azurewebsites.net",
  apiTokenStorageKey: "api_token",
  apiTransactionsAccessStorageKey: "api_transactions_access_token",
  recaptchaKey: "6LeVPXMUAAAAANLJknfyNfJw4gVvbkIhEpp_u4SS"
};

export default configuration;
